import React, { useState } from 'react'
import { MDBIcon, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit'

export const CarrierPrioritiesDataTable = ({ priorities }) => {
  const [order, setOrder] = useState()
  const columns = [
    {
      label: 'Logo',
      field: 'logo',
    },
    {
      label: 'Carrier',
      field: 'name',
      sortable: true,
    },
    {
      label: 'Description',
      field: 'description',
      sortable: true,
    },
  ]

  const _onToggle = col => () => {
    if (!columns.filter(column => column.field === col.field && column.sortable === true).length) return
    if (!order || order.col !== col.field) {
      setOrder({
        col: col.field,
        dir: 'asc',
      })
      return
    }
    if (order.dir === 'asc') {
      setOrder({
        col: col.field,
        dir: 'desc',
      })
      return
    }
    setOrder(null)
  }
  const _onSort = (dir, col) => e => {
    e.stopPropagation()
    if (order && col.field === order.col && dir === order.dir) {
      setOrder(null)
      return
    }
    setOrder({
      col: col.field,
      dir,
    })
  }
  const _renderHeaderLabel = col => {
    return {
      label: (
        <div
          className={`table-col-sorter d-flex justify-content-between align-items-center ${
            col.sortable ? 'is-sortable' : ''
          } ${order && order.col && order.dir && order.col === col.field ? 'sort-' + order.dir.toLowerCase() : ''}`}
          onClick={_onToggle(col)}
        >
          <label>{col.label}</label>
          <div className='sorter'>
            <div onClick={_onSort('asc', col)} className='up'>
              <MDBIcon icon='angle-up' />
            </div>
            <div onClick={_onSort('desc', col)} className='down'>
              <MDBIcon icon='angle-down' />
            </div>
          </div>
        </div>
      ),
      field: col.field,
    }
  }
  const displayColumns = columns.map(_renderHeaderLabel)
  const displayRows =
    priorities && priorities.length
      ? order
        ? priorities.filter(Boolean).sort((a, b) => {
            const aVal = a[order.col]
            const bVal = b[order.col]
            const cmp =
              typeof aVal === 'string' && typeof bVal === 'string'
                ? aVal.localeCompare(bVal)
                : String(aVal ?? '').localeCompare(String(bVal ?? ''))
            return order.dir === 'asc' ? cmp : -cmp
          })
        : priorities.filter(Boolean)
      : []

  return (
    <MDBTable striped bordered small className='text-capitalize'>
      <MDBTableHead>
        <tr>
          {displayColumns.map(col => (
            <th key={col.field}>{col.label}</th>
          ))}
        </tr>
      </MDBTableHead>
      {displayRows.length ? (
        <MDBTableBody>
          {displayRows.map((row, idx) => (
            <tr key={idx}>
              {displayColumns.map(col => (
                <td key={col.field}>{row[col.field]}</td>
              ))}
            </tr>
          ))}
        </MDBTableBody>
      ) : (
        <MDBTableBody>
          <tr>
            <td colSpan={displayColumns.length} className='text-center'>
              No Data Found
            </td>
          </tr>
        </MDBTableBody>
      )}
    </MDBTable>
  )
}
